import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import MetricsTable, { categoryColumn } from './MetricsTable';
import type { EvaluationMetrics } from '../../helpers/webinarStatisticsData';

interface DeviceFunnelProps {
  /** Je Anmeldegeraet (erste Anmeldung der Person). */
  signup: EvaluationMetrics[];
  /** Je Teilnahmegeraet (erstes Anwesenheits-Signal der Person) plus Zeile „Ohne Teilnahme“. */
  attendance: EvaluationMetrics[];
  totals: EvaluationMetrics;
}

/**
 * Geraete in zwei Sichten. Bis 2026-09-14 gab es nur einen Donut ueber Teilnahme-Signale, der
 * Personen mit zwei Geraeten doppelt zaehlte (fraeh4: 154 statt 140). Jetzt: je Person genau ein
 * Geraet, und zusaetzlich das Anmeldegeraet, womit sich der ganze Funnel je Geraet lesen laesst.
 */
const DeviceFunnel: FC<DeviceFunnelProps> = ({ signup, attendance, totals }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    <Box>
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        Funnel nach Anmeldegerät
      </Typography>
      <Typography variant="body2" sx={{ mb: 1.5, color: 'text.secondary' }}>
        Mit welchem Gerät sich die Personen angemeldet haben — und wie viele davon live dabei waren
        und gekauft haben. Jede Person zählt einmal (Gerät der ersten Anmeldung).
      </Typography>
      <MetricsTable
        rows={signup}
        leading={[
          categoryColumn(
            'Anmeldegerät',
            'Aus der Browser-Kennung beim Absenden des Anmeldeformulars.',
          ),
        ]}
        metrics={[
          'registrations',
          'timely',
          'attendees',
          'show_up_rate',
          'orders',
          'registration_conversion_rate',
          'attendee_conversion_rate',
          'cpa_revenue',
        ]}
        totals={totals}
        rowKey={(r) => r.category}
        defaultSortBy="registrations"
      />
    </Box>
    <Box>
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        Nach Teilnahmegerät
      </Typography>
      <Typography variant="body2" sx={{ mb: 1.5, color: 'text.secondary' }}>
        Womit die Live-Teilnehmer tatsächlich zugeschaut haben. Wer mit zwei Geräten dabei war,
        zählt beim Gerät, mit dem er zuerst im Webinar war. Die Zeile „Ohne Teilnahme“ sammelt Käufe
        von Personen, die nicht live dabei waren; „Teilnahme nicht belastbar“ Käufe aus Webinaren
        mit Tracking-Warnung.
      </Typography>
      <MetricsTable
        rows={attendance}
        leading={[categoryColumn('Teilnahmegerät', 'Gerät laut StealthSeminar-Player.')]}
        metrics={['attendees', 'orders', 'attendee_conversion_rate', 'cpa_revenue']}
        totals={totals}
        rowKey={(r) => r.category}
        defaultSortBy="attendees"
      />
    </Box>
  </Box>
);

export default DeviceFunnel;
